<template>
  <div>
    <b-modal ref="modal" :title="this.$t('edit-permissions')" size="s" @ok="okClicked">
    <b-form-group :label="this.$t('access-control')" class="mt-3">
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="form.accessControl"
        :options="options"
        name="access-control"
      />
    </b-form-group>
  </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ServicePermissionsModalEditForm',
  data() {
    return {
      form: {
        accessControl: null,
      },
      options: [
        { value: 'status', text: 'Status' },
        { value: 'control', text: 'Control' },
        { value: 'settings', text: 'Settings' },
      ],
    };
  },
  methods: {
    okClicked() {
      this.$emit('access-control-selected', this.form.accessControl);
    },
    show() {
      this.form.accessControl = null;
      this.$refs.modal.show();
    },
  },
};
</script>

<style scoped>

</style>
